<template>
    <div>
        <table class="form-table">
            <tbody>
                <tr>
                    <td>
                        <label>{{ $t('Use time of day schedule') }}:</label>
                    </td>
                    <td>
                        <CicCheckbox
                            id="campaign_use_tods"
                            :value="item.useSchedules"
                            @input="(val) => updateUseSchedules(val)"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
        <table v-if="item.useSchedules" id="time_of_day_schedule">
            <thead>
                <tr>
                    <th>{{ $t('Mon') }}</th>
                    <th>{{ $t('Tue') }}</th>
                    <th>{{ $t('Wed') }}</th>
                    <th>{{ $t('Thu') }}</th>
                    <th>{{ $t('Fri') }}</th>
                    <th>{{ $t('Sat') }}</th>
                    <th>{{ $t('Sun') }}</th>
                    <th>{{ $t('Start') }}</th>
                    <th>{{ $t('End') }}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(schedule, index) in item.schedules">
                    <td class="td-checkbox">
                        <CicCheckbox
                            :value="schedule.days.includes('Monday')"
                            @input="updateScheduleDays(index, 'Monday')"
                        />
                    </td>
                    <td class="td-checkbox">
                        <CicCheckbox
                            :value="schedule.days.includes('Tuesday')"
                            @input="updateScheduleDays(index, 'Tuesday')"
                        />
                    </td>
                    <td class="td-checkbox">
                        <CicCheckbox
                            :value="schedule.days.includes('Wednesday')"
                            @input="updateScheduleDays(index, 'Wednesday')"
                        />
                    </td>
                    <td class="td-checkbox">
                        <CicCheckbox
                            :value="schedule.days.includes('Thursday')"
                            @input="updateScheduleDays(index, 'Thursday')"
                        />
                    </td>
                    <td class="td-checkbox">
                        <CicCheckbox
                            :value="schedule.days.includes('Friday')"
                            @input="updateScheduleDays(index, 'Friday')"
                        />
                    </td>
                    <td class="td-checkbox">
                        <CicCheckbox
                            :value="schedule.days.includes('Saturday')"
                            @input="updateScheduleDays(index, 'Saturday')"
                        />
                    </td>
                    <td class="td-checkbox">
                        <CicCheckbox
                            :value="schedule.days.includes('Sunday')"
                            @input="updateScheduleDays(index, 'Sunday')"
                        />
                    </td>
                    <td style="text-align: center">
                        <CicTimePicker
                            :value="schedule.start"
                            :clearable="false"
                            format="HH:mm"
                            @input="(val) => updateSchedule(index, 'start', val)"
                        />
                    </td>
                    <td style="text-align: center">
                        <CicTimePicker
                            :value="schedule.end"
                            :clearable="false"
                            format="HH:mm"
                            @input="(val) => updateSchedule(index, 'end', val)"
                        />
                    </td>
                    <td style="padding: 0">
                        <IconButton
                            v-if="item.schedules.length > 0"
                            icon="remove-icon"
                            @click="removeSchedule(index)"
                        />
                    </td>
                </tr>
                <tr>
                    <td colspan="9"></td>
                    <td style="padding: 0"><IconButton icon="add-icon" @click="addSchedule" /></td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import IconButton from '@/components/controls/IconButton';
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import CicTimePicker from '@/components/inputs/CicTimePicker';

    export default {
        name: 'EditTimeOfDaySchedule',
        components: {
            CicTimePicker,
            CicCheckbox,
            IconButton,
        },
        props: {
            item: {
                type: Object,
                required: true,
            },
        },
        emits: ['change'],
        methods: {
            updateFieldValue(name, value) {
                this.$emit('change', name, value);
            },
            addSchedule() {
                const schedules = JSON.parse(JSON.stringify(this.item.schedules));
                schedules.push({ start: '00:00', end: '23:59', days: [] });
                this.updateFieldValue('schedules', schedules);
            },
            removeSchedule(index) {
                const schedules = JSON.parse(JSON.stringify(this.item.schedules));
                schedules.splice(index, 1);
                this.updateFieldValue('schedules', schedules);
            },
            updateSchedule(index, name, value) {
                const schedules = JSON.parse(JSON.stringify(this.item.schedules));
                schedules[index][name] = value;
                this.updateFieldValue('schedules', schedules);
            },
            updateScheduleDays(index, name) {
                const schedules = JSON.parse(JSON.stringify(this.item.schedules));
                const dayIndex = schedules[index].days.indexOf(name);
                if (dayIndex >= 0) {
                    schedules[index].days.splice(dayIndex, 1);
                } else {
                    schedules[index].days.push(name);
                }

                this.updateFieldValue('schedules', schedules);
            },
            updateUseSchedules(val) {
                this.updateFieldValue('useSchedules', val);
                const schedules = [];
                if (val) {
                    schedules.push({ start: '00:00', end: '23:59', days: [] });
                }
                this.updateFieldValue('schedules', schedules);
            },
        },
    };
</script>
